import { render, staticRenderFns } from "./ManageTribunal.vue?vue&type=template&id=51965a19&scoped=true"
import script from "./ManageTribunal.vue?vue&type=script&lang=js"
export * from "./ManageTribunal.vue?vue&type=script&lang=js"
import style0 from "./ManageTribunal.vue?vue&type=style&index=0&id=51965a19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51965a19",
  null
  
)

export default component.exports